const apiUrl = process.env.REACT_APP_API_URL;

export const fetchCategories = async (token) => {
  try {
    const response = await fetch(`${apiUrl}/categories`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch categories');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const deleteCategory = async (token, id) => {
  try {
    const response = await fetch(`${apiUrl}/categories/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error('Failed to delete category');
    }
    return response.json();
  } catch (error) {
    throw error;
  }
};
